// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"3b73a577","300":"27e67a5b","312":"009d1627","372":"054cb4ac","504":"62de701a","592":"db5cf8c0","768":"dd8d701f","792":"ddd48469","856":"6383cc2c"}[chunkId] + ".chunk.js";
};